import type { WorkflowGraph } from '../../graph';
import type { Store } from '../types';
import { generateGuid } from '../../graph/utils/id';
import { withSyncGuard } from '../sync/syncFlag';

type SetState = (partial: Partial<Store> | ((state: Store) => Partial<Store>)) => void;
type GetState = () => Store;

export function createEdgeActions(
  set: SetState,
  get: GetState,
  getGraph: () => WorkflowGraph | null | undefined,
) {
  return {
    connectMaterialToOperation(materialId: string, operationId: string): string {
      const id = generateGuid();
      const edgeId = id;

      set((state) => ({
        graphData: {
          ...state.graphData,
          flowEdges: {
            ...state.graphData.flowEdges,
            [id]: { id, edgeId, sourceId: materialId, targetId: operationId },
          },
        },
        ui: { ...state.ui, isDirty: true },
      }));

      const opSpec = get().graphData.operationNodes[operationId];
      const displayName = opSpec?.displayName ?? '';
      const archetype = opSpec?.archetype;
      withSyncGuard(set, () => {
        getGraph()?.connectMaterialToOperation(materialId, operationId, id, displayName, archetype);
      });

      return id;
    },

    connectOperationToMaterial(operationId: string, materialId: string): string {
      const id = generateGuid();
      const edgeId = id;

      set((state) => ({
        graphData: {
          ...state.graphData,
          flowEdges: {
            ...state.graphData.flowEdges,
            [id]: { id, edgeId, sourceId: operationId, targetId: materialId },
          },
        },
        ui: { ...state.ui, isDirty: true },
      }));

      const opSpec = get().graphData.operationNodes[operationId];
      const displayName = opSpec?.displayName ?? '';
      const archetype = opSpec?.archetype;
      withSyncGuard(set, () => {
        getGraph()?.connectOperationToMaterial(operationId, materialId, id, displayName, archetype);
      });

      return id;
    },

    removeFlowEdge(edgeId: string): void {
      set((state) => {
        const { [edgeId]: _, ...rest } = state.graphData.flowEdges;
        return {
          graphData: { ...state.graphData, flowEdges: rest },
          ui: { ...state.ui, isDirty: true },
        };
      });

      withSyncGuard(set, () => {
        getGraph()?.removeFlowEdge(edgeId);
      });
    },
  };
}
